import { render, staticRenderFns } from "./RestoreDeleted.vue?vue&type=template&id=775f7c36"
import script from "./RestoreDeleted.vue?vue&type=script&lang=js"
export * from "./RestoreDeleted.vue?vue&type=script&lang=js"
import style0 from "./RestoreDeleted.vue?vue&type=style&index=0&id=775f7c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports